if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        //this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.cart = document.querySelector('mini-cart');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        

        this.handleErrorMessage();

            this.submitButton.setAttribute('aria-disabled', true);
    this.submitButton.classList.add('loading');
    const loadingSpinner = this.querySelector('.loading-overlay__spinner') || this.querySelector('.loading__spinner');
    if (loadingSpinner) {
      loadingSpinner.classList.remove('hidden');
    }

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
          formData.append('sections_url', window.location.pathname);
          config.body = formData;
        } else {
          config.body = formData;
        }

        fetch(`${theme.routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
                        if (!soldOutMessage) return;
          this.submitButton.setAttribute('aria-disabled', true);
          const submitButtonSpan = this.submitButton.querySelector('span');
          if (submitButtonSpan) {
            submitButtonSpan.classList.add('hidden');
          }
          soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
                    } else if (!this.cart) {
          window.location = theme.routes.cart_url;
          return;
        }

                    if (!this.error)
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'product-form',
            productVariantId: formData.get('id'),
            cartData: response,
          });
        
        // Check if this is a Rescue Circle product and refresh page
        const isRescueCircle = this.form.getAttribute('data-product-handle') === 'rescue-circle' ||
                              window.location.pathname.includes('rescue-circle');
        
        if (isRescueCircle) {
          console.log('🔄 Rescue Circle added via product form - refreshing page');
          setTimeout(() => {
            window.location.reload();
          }, 1000);
          return; // Exit early to prevent other actions
        }
        
        this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
                    if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
        if (!this.error) this.submitButton.removeAttribute('aria-disabled');
        const loadingSpinner = this.querySelector('.loading-overlay__spinner') || this.querySelector('.loading__spinner');
        if (loadingSpinner) {
          loadingSpinner.classList.add('hidden');
        }
          });
      }

      

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = theme.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
